// extracted by mini-css-extract-plugin
export default {"productContainer":"Card_productContainer__T5l3W"};